export default __webpack_public_path__ + "static/media/i_wdt_c_5.cff32aef.mp3";